const constants = {
    player: {
        rentDay: 1,
        rentChangeStatusDay: 27,
        sumToWriteOffForDebt: 1000,
        probabilities: {
            courierJobEvent: 7,
            homeComingEvent: 3
        }
    },
    wife: {
        relationsTo: {
            goToBathroom: 25,
            bathTogether: 50,
            checkHerAss: 40,
            askForSex: 25,
            haveSex: 50, // temp
            homeEvents: 20
        }
    },
    missions: {
        daysAfterPillTreat: 2
    },
    homes: {
        apartments01: {
            places: ["main", "bedroom", "bathroom", "kitchen"],
            payment: 600,
            name: "CoolT Apartments"
        },
        initHome: {
            places: ["main"],
            payment: 0,
            name: "Family House"
        }
    },
    cars: {
        oldBMW: {
            name: "Old BMW",
        },
        van: {
            name: "Van (Company Property)",
            price: 40000
        }
    },
    works: {
        courier: {
            salaryPerDay: 20
        }
    }
};

export default constants;